<template>
  <b-card class="mb-3" body-class="py-2">
    <b-row class="align-items-end">
      <b-col md="2" sm="6">
        <b-form-group label="Desde" class="mb-1">
          <b-form-input type="date" v-model="local.from" size="sm"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="2" sm="6">
        <b-form-group label="Hasta" class="mb-1">
          <b-form-input type="date" v-model="local.to" size="sm"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="2" sm="6">
        <b-form-group label="Comparar" class="mb-1">
          <b-form-select v-model="local.compare" :options="compareOptions" size="sm"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="2" sm="6">
        <b-form-group label="Sucursal" class="mb-1">
          <b-form-select v-model="local.sucursal_id" :options="sucursalOptions" size="sm"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="2" sm="6">
        <b-form-group label="Canal" class="mb-1">
          <b-form-select v-model="local.channel_label" :options="channelOptions" size="sm"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="2" sm="6">
        <b-form-group label="Cliente" class="mb-1">
          <b-form-select v-model="local.customer_kind" :options="customerKindOptions" size="sm"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="align-items-end">
      <b-col md="2" sm="6">
        <b-form-group label="Membresía" class="mb-1">
          <b-form-select v-model="local.tier_code" :options="tierOptions" size="sm"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="2" sm="6">
        <b-form-group label="Zona" class="mb-1">
          <b-form-input v-model="local.zone" size="sm" placeholder="—"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="2" sm="6">
        <b-form-group label="Campaña" class="mb-1">
          <b-form-input v-model="local.campaign" size="sm" placeholder="—"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="2" sm="6">
        <b-form-group label="Promoción" class="mb-1">
          <b-form-input v-model="local.promotion_code" size="sm" placeholder="—"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4" sm="12" class="text-right">
        <b-button variant="primary" size="sm" @click="apply">Aplicar filtros</b-button>
        <b-button variant="outline-secondary" size="sm" @click="reset">Limpiar</b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import axios from 'axios';

// Filtros comunes de todos los reportes ejecutivos (doc 04 §1.1). Se persisten en
// el query string para que las tarjetas KPI naveguen conservando el contexto.
export default {
  name: 'ExecFilters',
  props: {
    value: { type: Object, default: () => ({}) }
  },
  data() {
    const today = new Date().toISOString().slice(0, 10);
    const first = today.slice(0, 8) + '01';
    return {
      local: this.buildInitial(first, today),
      sucursals: [],
      compareOptions: [
        { value: '', text: 'Sin comparación' },
        { value: 'previous_period', text: 'Periodo anterior' },
        { value: 'previous_year', text: 'Año anterior (AA)' }
      ],
      customerKindOptions: [
        { value: '', text: 'Todos' },
        { value: 'new', text: 'Nuevos' },
        { value: 'recurring', text: 'Recurrentes' }
      ],
      channelOptions: [
        { value: '', text: 'Todos' },
        { value: 'Salón', text: 'Salón' },
        { value: 'Para llevar', text: 'Para llevar' },
        { value: 'App propia', text: 'App propia' },
        { value: 'Uber Eats', text: 'Uber Eats' },
        { value: 'Rappi', text: 'Rappi' },
        { value: 'Teléfono', text: 'Teléfono' }
      ],
      tierOptions: [
        { value: '', text: 'Todas' },
        { value: 'bronce', text: 'Bronce' },
        { value: 'plata', text: 'Plata' },
        { value: 'oro', text: 'Oro' },
        { value: 'platino', text: 'Platino' }
      ]
    };
  },
  computed: {
    sucursalOptions() {
      return [{ value: '', text: 'Todas' }].concat(
        this.sucursals.map((s) => ({ value: s.id, text: s.name || ('Sucursal ' + s.id) }))
      );
    }
  },
  created() {
    // Hidrata desde el query string si viene con filtros (navegación entre pestañas).
    const q = this.$route.query || {};
    ['from', 'to', 'compare', 'sucursal_id', 'channel_label', 'customer_kind', 'tier_code', 'zone', 'campaign', 'promotion_code'].forEach((k) => {
      if (q[k] !== undefined && q[k] !== '') this.local[k] = q[k];
    });
    this.getSucursals();
    this.$emit('input', this.normalized());
    this.$emit('apply', this.normalized());
  },
  methods: {
    buildInitial(from, to) {
      return {
        from: from,
        to: to,
        compare: '',
        sucursal_id: '',
        channel_label: '',
        customer_kind: '',
        tier_code: '',
        zone: '',
        campaign: '',
        promotion_code: ''
      };
    },
    // Debe coincidir con el struct Filters de central (app/reports/exec/filters.go):
    // el rango va anidado en `period`, y zone/campaign/promotion_code tienen otro
    // nombre allá. Mandarlo plano hacía que el backend no viera un solo filtro: el
    // rango caía al default 1970-2999 y el reporte salía con todo el histórico.
    normalized() {
      const f = { period: { from: this.local.from, to: this.local.to } };
      if (this.local.compare) f.period.compare = this.local.compare;
      if (this.local.sucursal_id) f.sucursal_ids = [Number(this.local.sucursal_id)];
      if (this.local.channel_label) f.channel_labels = [this.local.channel_label];
      if (this.local.customer_kind) f.customer_kind = this.local.customer_kind;
      if (this.local.tier_code) f.tier_codes = [this.local.tier_code];
      if (this.local.zone) f.region = this.local.zone;
      if (this.local.campaign) f.attribution = { campaign: this.local.campaign };
      if (this.local.promotion_code) f.benefit_code = this.local.promotion_code;
      return f;
    },
    apply() {
      const f = this.normalized();
      // Persiste en query string (sin recargar) para conservar contexto.
      const q = Object.assign({}, this.$route.query, this.local);
      this.$router.replace({ query: q }).catch(() => {});
      this.$emit('input', f);
      this.$emit('apply', f);
    },
    reset() {
      const today = new Date().toISOString().slice(0, 10);
      const first = today.slice(0, 8) + '01';
      this.local = this.buildInitial(first, today);
      this.apply();
    },
    getSucursals() {
      axios.get('/sucursals')
        .then((res) => { this.sucursals = Array.isArray(res.data) ? res.data : []; })
        .catch(() => { this.sucursals = []; });
    }
  }
}
</script>
